import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitToastsContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { Manifest } from 'shared/components/Manifest';
import { Utp } from 'shared/components/Utp';
import { HowConnectOnlineBooking } from 'shared/components/HowConnectOnlineBooking';
import { FiveSteps } from 'shared/components/FiveSteps';
import { BlueBanner } from 'shared/components/BlueBanner';
import { Answers } from 'shared/components/Answers';
import { Footer } from 'shared/components/Footer';
import { ModalContainer } from '../ModalContainer';
import { GiftBannerContainer } from '../GiftBannerContainer';
import { NotificationsContainer } from '../Notifications';
import { UiKitRoot } from '@cian/ui-kit';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <Manifest />
              <Utp />
              <HowConnectOnlineBooking />
              <FiveSteps />
              <GiftBannerContainer />
              <BlueBanner />
              <Answers />
              <Footer />
              <ModalContainer />
              <NotificationsContainer />
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
